import eyecare from "assets/images/banners/home/internalmeds.png";
import aboutus from "assets/images/banners/about/optho.png";
import facility from "assets/images/banners/facility/optho.png";
import info from "assets/images/banners/info/internalMed.png";

export const data = {
  id: "internalMed",
  label: "Internal Medicine ",
  banner: ["Department of Internal Medicine e"],
  bannerImg: eyecare,
  aboutImg: aboutus,
  title: "Top Gynecologist in Chennai – Personalized Women's Health Care",
  description: "Find the best gynecologist in Chennai at Amrit Hospitals. Personalized women’s health care for maternity, fertility, and gynecological concerns.",
  keyword: "best gynecologist in Chennai, internal medicine doctor, internal medicine physician, general physician in chennai, thyroid doctor, thyroid specialist doctor, thyroid specialist, thyroid specialist in chennai, endocrinologist thyroid, best hospital for thyroid treatment in chennai, respiratory doctor, respiratory medicine doctor, respiratory specialist doctor, thyroid hospital in chennai",
   url: "https://www.amrithospitals.com/department-internal/general/internalMedicine",
  Imageme: "https://www.amrithospitals.com/static/media/internalmedicine.6f4ba1b48ab96b1801fe.jpg",
  about: [
    {
      text: "40+",
      subText: "Years of Experience",
    },
    {
      text: "2 Lac+",
      subText: "Surgeries",
    },
    {
      text: "4.8 Lac+",
      subText: "Happy Patients",
    },
    {
      text: "25,000+",
      subText: "Removed",
    },
  ],
  facilityImg: facility,
  infoImg: info,
  info: {
    heder: "Super Speciality",
    // subheader: "Expert Care for a Safe Delivery",
    // point1: "EXPERT SURGEONS , ADVANCED TECHNIQUES",
    // point2: "SAFE RECOVERY, COMPASSIONATE CARE",
  },
  facility: {
    mainHeader: "Department of Internal Medicine ",
    // subHeader: "Expert Care for Women's Health",
    content:
      "The Department of Internal Medicine at Amrit Hospital specializes in diagnosing and managing a wide range of adult health conditions. Utilizing advanced diagnostic technology and tailored treatments, we address both chronic and acute illnesses. We offer comprehensive care, including preventive services and management of complex conditions, to ensure optimal patient outcomes.",
  },
};
